import { render, staticRenderFns } from "./MultipleRegistration.vue?vue&type=template&id=de95f594"
import script from "./MultipleRegistration.vue?vue&type=script&lang=js"
export * from "./MultipleRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports